export const REDUCE_SIDEBAR = '@sidebar/REDUCE_SIDEBAR'
export const EXPAND_SIDEBAR = '@sidebar/EXPAND_SIDEBAR'
export const TOGGLE_SIDEBAR = '@sidebar/TOGGLE_SIDEBAR'
